import { render, staticRenderFns } from "./cAdminText.vue?vue&type=template&id=decfde60&scoped=true"
import script from "./cAdminText.vue?vue&type=script&lang=js"
export * from "./cAdminText.vue?vue&type=script&lang=js"
import style0 from "./cAdminText.vue?vue&type=style&index=0&id=decfde60&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "decfde60",
  null
  
)

export default component.exports